
import { StepModel } from '../../Models/step-model';
import { Utilities } from '../../utilities';

export class StepMock {

  private static models: StepModel[];
  private static  idCounter = 0;

  public static initMocks(){
    StepMock.models = [];
    StepMock.models.push({id:"ebetbeetttbt", ss_id:++this.idCounter, name:"Given user is on login page.", bddKeyword:"wuuwduwqnwfewefi", action:"weggmccgygyygg",object:"jahjd",suser:"jdbbvbdeyuev", commandSteps:["ebetbeetttbt"], _type:"step"});
  }
  public static findByObjectId(id: string):StepModel{
    let m = StepMock.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].id) return m[i];
    }
    return null;
  }

  public static addNewStep(step: StepModel){
    step.id = Utilities.makeid(10);
    step.ss_id = ++this.idCounter;
    StepMock.models.push(step);
  }

  public static findById(id:number):StepModel{
    let m = StepMock.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].ss_id) return m[i];
    }
    return null;
  }

  public static getItems():StepModel[]{
    return StepMock.models;
  }

  public static deleteModel(model: StepModel){
    let m = StepMock.models;
    for(let i = 0; i< m.length; i++){
      if(model.id == m[i].id) {
        StepMock.models.splice(i,1);
      }

    }
  }

}
